<template>
  <div class="font-scaler">
    <div class="scaler-toolbar">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon class="font-scaler-btn" v-bind="attrs" v-on="on" @click="decrease" aria-label="Disminuir tamaño de fuente">
            <v-icon>mdi-magnify-minus-outline</v-icon>
          </v-btn>
        </template>
        <span>Disminuir tamaño de fuente</span>
      </v-tooltip>

      <v-tooltip top v-if="fontScalerComponent.isActive">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon class="font-scaler-btn" v-bind="attrs" v-on="on" @click="reset" aria-label="Restaurar tamaño original">
            <v-icon>mdi-restore</v-icon>
          </v-btn>
        </template>
        <span>Restaurar tamaño de fuente original</span>
      </v-tooltip>

      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon class="font-scaler-btn" v-bind="attrs" v-on="on" @click="increase" aria-label="Aumentar tamaño de fuente">
            <v-icon>mdi-magnify-plus-outline</v-icon>
          </v-btn>
        </template>
        <span>Aumentar tamaño de fuente</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import { FontScalerComponent } from '@/modules/facturae/app/FontScalerComponent'

export default {
  name: 'FontScaler',
  props: {
    initialFactor: {
      type: Number,
      default: 1,
    },
    targetClasses: {
      type: [String, Array],
      required: true,
    },
  },
  data() {
    return {
      fontScalerComponent: new FontScalerComponent(this.initialFactor),
      observer: null,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.fontScalerComponent.remember(this.targetClasses)
      this.fontScalerComponent.apply(this.targetClasses)

      this.observer = new MutationObserver(() => {
        this.fontScalerComponent.remember(this.targetClasses)
        this.fontScalerComponent.apply(this.targetClasses)
      })

      this.observer.observe(document.body, {
        childList: true,
        subtree: true,
      })
    })
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect()
    }
  },
  methods: {
    increase() {
      this.fontScalerComponent.increase(this.targetClasses)
    },
    decrease() {
      this.fontScalerComponent.decrease(this.targetClasses)
    },
    reset() {
      this.fontScalerComponent.reset(this.targetClasses)
    },
  },
}
</script>

<style scoped>
.font-scaler {
  .scaler-toolbar {
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    height: 100% !important;
    border: 1px solid rgba(0, 0, 0, 0.2) !important;
    border-radius: 8px !important;
    background-color: white !important;
    margin-left: 10px;
    gap: 4px !important;
    padding: 4px !important;
  }

  .font-scaler-btn {
    color: rgba(0, 0, 0, 0.54) !important;
    font-weight: 500 !important;
    width: 40px !important;
    height: 40px !important;
    min-width: 40px !important;
    border: none !important;
  }

  .font-scaler-btn .v-icon {
    font-size: 28px !important;
  }
}
</style>
